import { useMutation } from '@tanstack/react-query';

import { extractPartyForOneDocumentEnqueue } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useExtractPartyFromEmail() {
  return useMutation({
    mutationFn: ({
      link,
      documentId,
      filename,
    }: {
      link: string;
      documentId: string;
      filename: string;
    }) =>
      extractPartyForOneDocumentEnqueue(
        {
          body: {
            link,
            document_id: documentId,
            filename,
          },
        },
        wgApi,
      ),
  });
}
